<template>
    <div>
        <div class="form-group col-12">
            <label for="name">Name</label>
            <input
                id="name"
                v-model="disclaimer.name"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('name')
                }"
                dir="auto"
                placeholder="Name"
            />
            <div class="invalid-feedback">
                {{ getError('name') }}
            </div>
        </div>

        <div class="form-group col-12">
            <wysiwyg-editor
                v-model="disclaimer.content"
                label="Content"
                :error-border="hasError('content')"
            />
            <small v-if="hasError('content')" class="error-box">
                {{ getError('content') }}
            </small>
        </div>

        <div class="form-group col-12">
            <label>Manual sign?</label>
            <b-form-checkbox v-model="disclaimer.isManualSign" switch />
        </div>
    </div>
</template>

<script>
import WysiwygEditor from '@/components/elements/WysiwygEditor';

export default {
    components: {
        WysiwygEditor
    },

    props: {
        value: {
            type: Object,
            required: true
        },
        editMode: {
            type: Boolean,
            required: true
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            disclaimer: {}
        };
    },

    watch: {
        disclaimer() {
            this.$emit('input', this.disclaimer);
        }
    },

    created() {
        this.disclaimer = { ...this.value };
    },

    methods: {
        hasError(key) {
            return (
                (this.validation.disclaimer[key] &&
                    this.validation.disclaimer[key].$error) ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.disclaimer,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
